import { IWidget, IWidgetDefinition, IUrlParamWidget } from '../../common/core';
import { IQuerySubscribeSettings } from './query-subscribe.settings';

var template = require("./template.html");
var styles = require("./styles.scss").toString();


class QuerySubscribeData {
    email: string;
    loading = false;

    msgSubscriptionAdded = 'Subscription has been added';
    msgSubscriptionCanceled = 'Subscription has been canceled';

    constructor(private widget: IWidget<QuerySubscribeData, IQuerySubscribeSettings, null>) {
    }

    subscribe() {
        this.loading = true;
        this.widget.awaitGlobalQuery().then(query => {
            var settings: {
                url: string,
                query: string,
                email?: string,
                filters?: string[],
                view_id?: string
            } = {
                url: this.getPageUrl(),
                query: query,
                view_id: this.widget.service.sjSearchInstance.options.view
            };

            var email = this.getEmail();
            if (email) {
                settings.email = email;
            }

            var filters = [];
            var searchInput = this.widget.service.getWidgetById('search-1').component;
            if (searchInput.state.searchString) {
                filters.push(searchInput.state.searchString);
            }
            this.widget.service.getAllWidgets().forEach(function (w) {
                if (w.definition && w.definition.getSubFilters) {
                    var widgetFilters = w.definition.getSubFilters(w);
                    if (widgetFilters) {
                        widgetFilters.forEach(function (filter) {
                            filters.push(`${filter.widgetLabel}:${filter.label}`);
                        });
                    }
                }
            });
            settings.filters = filters;

            this.widget.service.sjclient.raw.post('/processors/query_subscribe/call/subscribe', {}, {
                settings: settings
            }, data => {
                this.onSubscribed(data.success && data.result && data.result.sub_id);
            }, err => {
                this.onSubscribed(false);
            });
        });
    }

    getSupportedWidgets() {
        return [
            'search',
            'textfacet',
            'treefacet'
        ];
    }

    getWidgetUrlParam(widgetWithParam: { data?: IUrlParamWidget }) {
        if (widgetWithParam.data?.getUrlParamName) {
            return widgetWithParam.data.getUrlParamName();
        }
    }

    getWidgetUrlValue(widgetWithParam: { data?: IUrlParamWidget }) {
        if (widgetWithParam.data?.getUrlValue) {
            return widgetWithParam.data.getUrlValue();
        }
    }

    getPageUrl() {
        var supportedWidgetsMap = this.getSupportedWidgets().reduce((res, item) => {
            res[item] = 1;
            return res;
        }, {});

        var queryParams = {};
        this.widget.service.getAllWidgets().filter(w => {
            return supportedWidgetsMap[w.type];
        }).forEach(w => {
            var urlParam = this.getWidgetUrlParam(w);
            var urlValue = this.getWidgetUrlValue(w);
            if (urlParam) {
                queryParams[urlParam] = urlValue;
            }
        });

        var urlParams = this.widget.service.serializeParams(queryParams);

        if (window['SHOOJU_CONFIG']) {
            var server = this.widget.service.authService.server;
            var tag = window['SJSearchLoader'].tag;
            switch (tag) {
                case 'alpha':
                case 'beta':
                    server += `/${tag}.html`
                    break;
                default:
                    server += '/';
                    break;
            }
            return `${server}#views/${this.widget.service.g.get_view_details().id}?${urlParams || ''}`;
        } else {
            var urlWithPath = `${location.protocol}//${location.hostname}${(location.port ? ":" + location.port : "")}${location.pathname}`;
            var routerHandler = this.widget.service.getRouterHandler();
            if (routerHandler === 'url') {
                return `${urlWithPath}?${urlParams || ''}`;
            } else {
                return `${urlWithPath}${location.search || ""}#?${urlParams || ''}`;
            }
        }
    }

    onSubscribed(success) {
        if (success) {
            this.widget.service.addMessage({
                message: this.msgSubscriptionAdded,
                type: 'info'
            });
        }
        this.loading = false;
    }

    unsubscribe(id) {
        this.widget.service.sjclient.raw.post('/processors/query_subscribe/call/unsubscribe', {}, {
            settings: {
                sub_id: id
            }
        }, data => {
            if (data.success) {
                this.widget.service.addMessage({
                    message: this.msgSubscriptionCanceled,
                    type: 'info'
                });
            }
        }, err => { });
    }

    getEmail() {
        if (!this.widget.settings.namedUser) {
            return this.email;
        }
    }

    afterInit() {
        var q = location.search;
        if (q && q[0] == '?') {
            q = q.substr(1, q.length - 1);
        }

        var qParams = {};
        q.split('&').forEach(p => {
            var parts = p.split('=');
            qParams[parts[0]] = parts[1];
        });

        var unsubscribeId = qParams['sj-unsubscribe'];
        if (unsubscribeId) {
            this.unsubscribe(unsubscribeId);

            delete qParams['sj-unsubscribe'];

            var ps = [];
            for (var k in qParams) {
                ps.push(`${k}=${qParams[k]}`);
            }

            var search = ps.length ? ('?' + ps.join('&')) : '';
            var url = window.location.pathname + search + window.location.hash;
            window.history.replaceState({}, document.title, url);
        }
    }
}

var widgetDefinition: IWidgetDefinition<QuerySubscribeData, IQuerySubscribeSettings, null> = {
    init(widget) {
        widget.data = new QuerySubscribeData(widget);
    },
    afterInit(widget) {
        widget.data.afterInit();
    },
    template: template,
    styles: styles
};

export { QuerySubscribeData, widgetDefinition };